module.exports = __webpack_public_path__ + "img/Group 87.50cc1e35.jpg";